// extracted by mini-css-extract-plugin
export default {"container":"EventsList_container__4wNhO","list":"EventsList_list__zSwTc","noEvents":"EventsList_noEvents__Z-wxP"};